import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, TiposEnsino } from './types';

export const INITIAL_STATE: TiposEnsino = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): TiposEnsino {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPOS_ENSINO_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.TIPOS_ENSINO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.TIPOS_ENSINO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
